import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import InfoText from './InfoText';

const Info = ({ ...props }) => {
  const { className, category, expirationDate, creationDate, balance } = props;

  return (
    <Box display="flex" flexDirection="column" className={className}>
      <InfoText title="Producto:" description={category} />
      <InfoText title="Fecha canje:" description={creationDate} date />
      <InfoText title="Válido hasta:" description={expirationDate} date />
      {balance && (
        <InfoText title="Saldo: $" description={balance} type={'saldo'} />
      )}
    </Box>
  );
};

Info.propTypes = {
  className: PropTypes.string,
  category: PropTypes.string,
  expirationDate: PropTypes.string,
  creationDate: PropTypes.string,
  balance: PropTypes.string,
};

export default Info;
